import { defineStore } from 'pinia';
import { store } from '/@/store';
import { IFeature } from '/@/api/common/model/common';
import { fetchFeaturesApi } from '/@/api/common';

export const useFeatureStore = defineStore('feature', {
  state: () => ({
    features: [] as IFeature[],
  }),
  actions: {
    async fetchFeatures() {
      return new Promise(async (res, rej) => {
        try {
          this.features = await fetchFeaturesApi();
          res(this.features);
        } catch (error) {
          rej(error);
        }
      });
    },
  },
  getters: {
    getAllFeatures(state) {
      return state.features;
    },
    getFeatureStateByName(state) {
      return (name: string) => {
        const targetFeature = state.features.find((item) => item.name === name);
        // 开关废弃了的话，就默认允许访问
        if (!targetFeature) {
          return true;
        }
        return targetFeature.allow;
      };
    },
  },
});

// Need to be used outside the setup
export function useFeatureStoreWithOut() {
  return useFeatureStore(store);
}
